<script>
import Swal from "sweetalert2";
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "MyAdvers",
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let profiles = ref([])

    function load_profile() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'advers',}, 'user_profiles', true).then((result) => {

        loading.value = false
        let res = result.data
        if (res.status != 'error') {
          profiles.value = res
        }

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_profile()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_profile()
            }
          })
        }
      })

    }
    load_profile()

    function delete_adver(id) {

      Swal.fire({
        text: "آیا میخواهید آگهی را حذف کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {

        if (result.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action: 'adver', id: id} , 'delete_items').then((result) => {

            loading.value = false
            let res = result.data
            if (res.status == 'ok') {

              Swal.fire({
                position: "center",
                icon: "success",
                title: "آگهی با موفقیت حذف شد",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                load_profile()
              })

            } else {

              Swal.fire({
                position: "center",
                icon: "error",
                title: "متاسفانه آگهی حذف نشد",
                showConfirmButton: false,
                timer: 1500,
              });

            }

          })

        }

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              delete_adver(id)
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              delete_adver(id)
            }
          })
        }
      })

    }

    function Upgrade_adver(id) {

      Swal.fire({
        title: "آیا میخواهید آگهی را ارتقاء دهید؟",
        text: "آگهی شما میتواند تنها 2 مرتبه ارتقاء یابد!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "ارتقای آگهی",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {

        if (result.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action: 'grow_adver', profile_id: id} , 'my_profile_action').then((result) => {

            loading.value = false
            let res = result.data
            if (res.status == 'ok') {

              Swal.fire({
                position: "center",
                icon: "success",
                title: "آگهی با موفقیت ارتقاء یافت",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                load_profile()
              })

            } else {

              Swal.fire({
                position: "center",
                icon: "error",
                title: "متاسفانه آگهی ارتقاء نیافت!",
                showConfirmButton: false,
                timer: 1500,
              });

            }

            if (res.event == 'More than 2 is not allowed') {

              Swal.fire({
                position: "center",
                icon: "error",
                title: "متاسفانه آگهی خود را بیش از 2 مرتبه ارتقاء داده اید!",
                showConfirmButton: false,
                timer: 1500,
              });

            }

          }).catch((result) => {

            loading.value = false
            if (result.message == 'Network Error') {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'تلاش مجدد',
                text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
              }).then((result) => {
                if (result.isConfirmed) {
                  Upgrade_adver(id)
                }
              })
            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'تلاش مجدد',
                text: '!خطای ارتباط با سرور',
              }).then((result) => {
                if (result.isConfirmed) {
                  Upgrade_adver(id)
                }
              })
            }
          })
        }
      })
    }


    return {

      loading,
      profiles,
      delete_adver,
      Upgrade_adver,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          آگهی های من
        </p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>

      </div>
    </div>
    <br>
    <br>
    <br>


    <div class="p-body mt-2">

      <div v-if="profiles.length == 0 "
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/businessman.svg" alt="">
          <br>
          <p class="font-4 ">
            !در حال حاضر شما آگهی ندارید
          </p>
        </div>
      </div>


      <div v-else>

        <div v-for="item in profiles" :key="item.id" class="">
          <div class="bg-white mb-3 text-black shadow-costom rounded-4 p-2">

            <router-link :to="{name:'DetailsAdvertising' , params:{adver_id: item.id}}"
                         class="d-flex justify-content-between text-decoration-none text-black">
              <div style="width:9rem;height: 9rem" class="">
                <img v-if="item.pic == null || item.pic.length == 0 " class="img_executives rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

                <img v-else class="w-100 h-100 rounded-4" :src="item.pic" alt="">
              </div>

              <div style="width: calc(100% - 9rem)" class="px-2 py-2">
                <p class="font-4 font-bold mb-2 text-end">{{ item.adver_name }}</p>
                <p class="text_information mb-2 font-5">{{ item.description }}</p>
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center">
                    <p class="m-0 font-5 d-flex">
                      <span>بازدید</span>
                      &nbsp;
                      <span class="font-bold">{{ item.visit }}</span>
                    </p>
                    <img style="height: .9rem" class="mx-1" src="../assets/img/see.svg" alt="">
                  </div>
                  <div class="overflow-hidden d-flex align-items-center">
                    <p class="m-0 font-5 text-end" :class="{'txtoverflow':item.state.length + item.city.length > 15}">
                      <span>{{ item.state }}</span>
                      -
                      <span>{{ item.city }}</span>
                    </p>
                  </div>
                </div>

              </div>
            </router-link>

            <hr>

            <div class="">

              <div class="w-100 d-flex justify-content-between mb-2">

                <v-btn @click="Upgrade_adver(item.id)"
                       class="rounded-3 h-100 w-30 text-black border-costom py-2 px-2 font-5 font-bold bg-main">
                  ارتقای آگهی
                  <!--                  <img style="width: 15px" src="../assets/img/increase.svg" alt="">-->
                </v-btn>

                <v-btn @click="delete_adver(item.id)"
                       class="rounded-3 h-100 w-30 text-black border-costom py-2 px-2 font-5 font-bold bg-red mx-1">
                  حذف
                  <!--                  <img style="width: 15px" src="../assets/img/trash-bin.svg" alt="">-->
                </v-btn>

                <router-link :to="{name:'AddNewAdvertising' , params:{action:item.id}}"
                             class="w-30 text-decoration-none">
                  <v-btn class="rounded-3 h-100 w-100 text-black border-costom py-2 px-2 font-5 font-bold bg-orange">
                    ویرایش
                    <!--                  <img style="width: 15px" src="../assets/img/pencil.svg" alt="">-->
                  </v-btn>
                </router-link>

              </div>

              <router-link v-if="item.chat_active == 1" :to="{name:'ChatsProfile' , params:{'id':item.id , 'type':'adver'}}">
                <v-btn class="w-100 bg-green rounded-3 font-4 text-black py-2">نمایش چت ها</v-btn>
              </router-link>

              <div v-else>
                <v-btn class="w-100 bg-unavailable text-decoration-none h-100 rounded-3 text-black py-2">نمایش چت ها
                </v-btn>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="new_profile w-100 max_width">
      <router-link :to="{name:'AddNewAdvertising' , params:{action:'new'}}" class="text-decoration-none">
        <v-btn class="p-3 h-100 border-costom rounded-4 bg-color font-4 text-white mx-4">
          افزودن آگهی جدید
        </v-btn>
      </router-link>
    </div>
  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">آگهی های من</div>

    <div class="p-4 bg-white rounded-4 w-75 m-auto">

      <div v-if="profiles.length === 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/businessman.svg" alt="">
          <br>
          <p class="font-4 ">
            !در حال حاضر شما آگهی ندارید
          </p>
        </div>
      </div>


      <div v-else>

        <div v-for="item in profiles" :key="item.id" class="">

          <div class="bg-white mb-3 text-black shadow-costom rounded-4 p-2">

            <router-link :to="{name:'DetailsAdvertising' , params:{adver_id: item.id}}" class="d-flex justify-content-between text-decoration-none text-black">
              <div style="width: 10rem;height: 10rem" class="">
                <img v-if="item.pic == null || item.pic.length == 0 " class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="w-100 h-100 rounded-4" :src="item.pic" alt="">
              </div>

              <div style="width: calc(100% - 10.5rem)" class="d-flex flex-column justify-content-around px-2 py-2">
                <p class="font-3 font-bold mb-2 text-end">{{ item.adver_name }}</p>
                <p class="text_information mb-2 font-4">{{ item.description }}</p>
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="m-0 font-4 text-end">
                      <span>{{ item.state }}</span>
                      -
                      <span>{{ item.city }}</span>
                    </p>
                  </div>
                  <div class="d-flex align-items-center">
                    <img style="height: .8rem" class="mx-1" src="../assets/img/see.svg" alt="">
                    <p class="m-0 font-4 d-flex">
                      <span class="font-bold">{{ item.visit }}</span>
                      &nbsp;
                      <span>بازدید</span>
                    </p>
                  </div>
                </div>

              </div>
            </router-link>

            <hr>

            <div class="">

              <div class="w-100 d-flex justify-content-between mb-2">

                <v-btn @click="Upgrade_adver(item.id)"
                       class="rounded-3 h-75 w-30 text-black border-costom py-3 px-2 font-5 font-bold bg-main">
                  ارتقای آگهی
                  <!--                  <img style="width: 15px" src="../assets/img/increase.svg" alt="">-->
                </v-btn>

                <v-btn @click="delete_adver(item.id)"
                       class="rounded-3 h-75 w-30 text-black border-costom py-3 px-2 font-5 font-bold bg-red mx-1">
                  حذف
                  <!--                  <img style="width: 15px" src="../assets/img/trash-bin.svg" alt="">-->
                </v-btn>

                <router-link :to="{name:'AddNewAdvertising' , params:{action:item.id}}"
                             class="w-30 text-decoration-none">
                  <v-btn class="rounded-3 h-100 w-100 text-black border-costom py-3 px-2 font-5 font-bold bg-orange">
                    ویرایش
                    <!--                  <img style="width: 15px" src="../assets/img/pencil.svg" alt="">-->
                  </v-btn>
                </router-link>

              </div>

              <router-link :to="{name:'ChatsProfile' , params:{'id':item.id , 'type':'adver'}}" v-if="item.chat_active == 1">
                <v-btn class="w-100 h-100 bg-green rounded-3 font-4 text-black py-2">نمایش چت ها</v-btn>
              </router-link>

              <div v-else>
                <v-btn class="w-100 bg-unavailable text-decoration-none h-75 rounded-3 text-black py-2">نمایش چت ها
                </v-btn>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>
    <br>
    <div class="new_profile w-100 max_width">
      <router-link :to="{name:'AddNewAdvertising' , params:{action:'new'}}" class="text-decoration-none">
        <v-btn class="p-3 h-100 border-costom rounded-4 bg-color font-4 text-white mx-4">
          افزودن آگهی جدید
        </v-btn>
      </router-link>
    </div>
  </div>

</template>

<style scoped>

.new_profile {
  position: fixed;
  bottom: 20px;
}

.img_executives {
  width: 100%;
  height: 130px;
}

.text_information {
  height: 57px;
  width: 100%;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  display: flex;
  align-items: center;
}

</style>